import styled from 'styled-components';

import { PageVariant } from '@/features/course/admin/types/page';
import { IconButton } from '@/ui/Button';
import { Icon } from '@/ui/Icon';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui/DropdownMenu';

const ActionItemStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CourseDrawerModuleAddActivityButton = ({ onAddClick }: { onAddClick: (type: PageVariant) => void }): JSX.Element => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <IconButton icon="plus" buttonVariant="buddySmall" />
    </DropdownMenuTrigger>
    <DropdownMenuContent variant="subtle" side="bottom" align="end">
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.PAGE)}>
        <ActionItemStyled>
          <Icon icon={['far', 'rectangle']} />
          Page
        </ActionItemStyled>
      </DropdownMenuItem>
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.REFLECTION)}>
        <ActionItemStyled>
          <Icon icon={['far', 'comment-pen']} />
          Reflection
        </ActionItemStyled>
      </DropdownMenuItem>
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.QUIZ)}>
        <ActionItemStyled>
          <Icon icon={['far', 'game-board-simple']} />
          Quiz
        </ActionItemStyled>
      </DropdownMenuItem>
      <DropdownMenuItem variant="subtle" onSelect={() => onAddClick(PageVariant.ASSIGNMENT)}>
        <ActionItemStyled>
          <Icon icon={['far', 'pen-line']} />
          Assignment
        </ActionItemStyled>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
